import { render, staticRenderFns } from "./reliableResult.vue?vue&type=template&id=c15d578a&scoped=true"
import script from "./reliableResult.vue?vue&type=script&lang=js"
export * from "./reliableResult.vue?vue&type=script&lang=js"
import style0 from "./reliableResult.vue?vue&type=style&index=0&id=c15d578a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15d578a",
  null
  
)

export default component.exports